import { render, staticRenderFns } from "./SpecialInitiativesTable.vue?vue&type=template&id=0c89b1da&scoped=true&"
import script from "./SpecialInitiativesTable.vue?vue&type=script&lang=ts&"
export * from "./SpecialInitiativesTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialInitiativesTable.vue?vue&type=style&index=0&id=0c89b1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89b1da",
  null
  
)

export default component.exports